(() => {
  'use strict';
  const template = document.getElementById('pir-size-range-template');
  if (!template) return;
  const selector = '[id="snize_filters_block_snize_facet1"]';
  const mounted = new WeakMap();
  const parse = value => {
    const match = value.trim().match(/^(\d+(?:\.\d+)?)\s*(?:"|″|in(?:ches)?)?$/i);
    return match ? Number(match[1]) : NaN;
  };
  function enhance(block) {
    const list = block.querySelector('.snize-product-filters-list');
    const title = block.querySelector('.snize-product-filters-title');
    if (!list || !title) return;
    const inputs = [...list.querySelectorAll('input[type="checkbox"]')];
    const values = inputs.map(input => ({value: input.value, size: parse(input.value), checked: input.checked}));
    if (values.length < 2 || values.some(item => !Number.isFinite(item.size))) return;
    values.sort((a, b) => a.size - b.size);
    const signature = values.map(item => item.value + ':' + item.checked).join('|');
    const old = mounted.get(block);
    if (old && old.signature === signature && old.panel.isConnected) return;
    if (old) old.panel.remove();
    block.classList.remove('pir-has-size-range');
    const panel = template.content.firstElementChild.cloneNode(true);
    const boxes = [...panel.querySelectorAll('input[type="number"]')];
    const sliders = [...panel.querySelectorAll('input[type="range"]')];
    const output = panel.querySelector('output');
    const apply = panel.querySelector('[data-size-apply]');
    const reset = panel.querySelector('[data-size-reset]');
    const selected = values.filter(item => item.checked);
    let low = selected.length ? values.indexOf(selected[0]) : 0;
    let high = selected.length ? values.indexOf(selected[selected.length - 1]) : values.length - 1;
    if (selected.length && selected.length !== high - low + 1) return;
    boxes.forEach(box => {
      box.step = '0.5';
      box.min = values[0].size;
      box.max = values[values.length - 1].size;
    });
    sliders.forEach(slider => {
      slider.min = 0;
      slider.max = values.length - 1;
      slider.step = 1;
    });
    function paint(syncBoxes = true) {
      if (syncBoxes) {
        boxes[0].value = values[low].size;
        boxes[1].value = values[high].size;
      }
      sliders[0].value = low;
      sliders[1].value = high;
      sliders[0].setAttribute('aria-valuetext', values[low].size + ' inches');
      sliders[1].setAttribute('aria-valuetext', values[high].size + ' inches');
      panel.style.setProperty('--size-low', low / (values.length - 1) * 100 + '%');
      panel.style.setProperty('--size-high', high / (values.length - 1) * 100 + '%');
      sliders[0].style.zIndex = low === high && low === 0 ? '3' : '2';
      output.textContent = values[low].size + '″ – ' + values[high].size + '″';
    }
    sliders.forEach((slider, index) => slider.addEventListener('input', () => {
      if (index === 0) low = Math.min(Number(slider.value), high);
      else high = Math.max(Number(slider.value), low);
      paint();
    }));
    function stepSize(index, direction) {
      if (index === 0) low = Math.max(0, Math.min(high, low + direction));
      else high = Math.max(low, Math.min(values.length - 1, high + direction));
      paint();
    }
    boxes.forEach((box, index) => box.addEventListener('keydown', event => {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        stepSize(index, event.key === 'ArrowDown' ? -1 : 1);
      }
    }));
    boxes.forEach((box, index) => box.addEventListener('input', event => {
      const number = box.valueAsNumber;
      const previous = values[index === 0 ? low : high].size;
      if (event.isTrusted && !event.inputType && Number.isFinite(number) && number !== previous) {
        stepSize(index, number < previous ? -1 : 1);
        return;
      }
      if (Number.isFinite(number)) {
        if (index === 0) {
          const next = values.findIndex(item => item.size >= number);
          low = Math.min(next < 0 ? values.length - 1 : next, high);
        } else {
          let next = values.length - 1;
          while (next > 0 && values[next].size > number) next--;
          high = Math.max(next, low);
        }
      }
      paint(false);
    }));
    boxes.forEach(box => box.addEventListener('change', () => paint()));
    function navigate(clear) {
      const url = new URL(location.href);
      if (clear || (low === 0 && high === values.length - 1)) url.searchParams.delete('rb_snize_facet1');
      else url.searchParams.set('rb_snize_facet1', values.slice(low, high + 1).map(item => item.value).join('|'));
      url.searchParams.set('page', '1');
      location.assign(url.href);
    }
    apply.addEventListener('click', () => navigate(false));
    reset.addEventListener('click', () => navigate(true));
    panel.addEventListener('keydown', event => {
      if (event.key === 'Enter' && event.target.matches('input[type="number"]')) {
        event.preventDefault();
        event.target.blur();
        navigate(false);
      }
    });
    block.classList.add('pir-has-size-range');
    title.classList.remove('open');
    title.setAttribute('aria-expanded', 'false');
    list.insertAdjacentElement('afterend', panel);
    mounted.set(block, {signature, panel});
    paint();
  }
  let queued = false;
  function discover() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      document.querySelectorAll(selector).forEach(enhance);
    });
  }
  const root = document.getElementById('main-content') || document.body;
  new MutationObserver(records => {
    if (records.some(record => !record.target.closest?.('.pir-size-range'))) discover();
  }).observe(root, {childList: true, subtree: true});
  window.addEventListener('popstate', discover);
  discover();
})();